import Infinite from '@admin/components/infinite'
import Message from '@admin/components/message'
import Img from '@admin/components/html/img'
import Icon from '@admin/components/icon'
import PropTypes from 'prop-types'
import React from 'react'
import Grid from './grid'
import List from './list'

class Folder extends React.Component {

  static contextTypes = {
    provider: PropTypes.object
  }

  static propTypes = {
    allow: PropTypes.object,
    folder: PropTypes.object,
    files: PropTypes.array,
    records: PropTypes.array,
    view: PropTypes.string,
    onAdd: PropTypes.func,
    onChangeFolder: PropTypes.func,
    onRemove: PropTypes.func,
    onUp: PropTypes.func
  }

  _handleUp = this._handleUp.bind(this)

  render() {
    const { provider } = this.context
    const { folder } = this.props
    return (
      <div className="maha-attachments-drive-folder">
        <div className="maha-attachments-drive-header">
          <div className="maha-attachments-drive-header-breadcrumb" onClick={ this._handleUp }>
            <div className="maha-attachments-drive-header-back">
              { folder.item_id ?
                <Icon icon="chevron-left" /> :
                <Img src={`/imagecache/w=20&h=20${provider.logo}`} />
              }
            </div>
            <div className="maha-attachments-drive-header-label">
              { folder.label }
            </div>
          </div>
        </div>
        <div className="maha-attachments-drive-results">
          <Infinite { ...this._getInfinite() } />
        </div>
      </div>
    )
  }

  _getInfinite() {
    const { allow, files, folder, view, onAdd, onChangeFolder, onRemove } = this.props
    const code = folder.code || 'drive'
    const empty = {
      icon: 'folder-open-o',
      title: 't(Empty Folder)',
      text: 't(There are no list in this folder)'
    }
    return {
      endpoint: `/api/admin/drive/items/folders/${code}`,
      empty: <Message { ...empty } />,
      notFound: <Message { ...empty } />,
      layout: view === 'list' ? List : Grid,
      props: {
        allow,
        files,
        onAdd,
        onChangeFolder,
        onRemove
      }
    }
  }

  _handleUp() {
    const { folder } = this.props
    if(!folder.item_id) return
    this.props.onUp()
  }

}

export default Folder
